import { Divider, Flex, Loading } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import invariant from 'tiny-invariant';

import { useWorkflowStackSiderView } from '@/features/workflow/hooks/stack-sider-view';
import { useWorkflow } from '@/features/workflow/hooks/workflow';
import { WorkflowDetailsCard } from './WorkflowDetailsCard';
import { StageContent } from './stage/StageContent';

export const WorkflowDetails: FC = () => {
  const { t } = useTranslation();
  const stackSiderView = useWorkflowStackSiderView();

  const siderConfig = stackSiderView.lastItem?.config;

  invariant(
    siderConfig?.viewType === 'workflow-details',
    t('unreachable-code'),
  );

  const workflow = useWorkflow(siderConfig.id);

  if (workflow.isPending) {
    return <Loading />;
  }

  if (!workflow.data) {
    return null;
  }

  return (
    <Flex vertical gap={16}>
      <WorkflowDetailsCard workflow={workflow.data} />
      <Divider />
      <StageContent />
    </Flex>
  );
};
